import { Component,
         OnInit }                 from '@angular/core';
import { Router }                 from '@angular/router';
import { JwtHelper }              from 'angular2-jwt';
import { AuthService }            from '../shared/auth.service';
import { Observable }             from 'rxjs/Observable';
import { Globals }                from './../common/globals';
import { PortalTypeEnum }         from '../login/login.model';

@Component({
  selector: 'sa-menu',
  template: require('./menu.component.html'),
  styles: [require('./menu.component.scss')]
})
export class MenuComponent implements OnInit {

  public jwtHelper: JwtHelper = new JwtHelper();
  public currentDate: Date = new Date();
  public opened = false;
  public userName = '';
  public showMenu = false;

  public portalTypes = PortalTypeEnum;

  constructor(
    public router: Router,
    private authService: AuthService,
    public globals: Globals) {
  }

  ngOnInit() {
    Observable.interval(333).subscribe(x => {
      this.currentDate = new Date();
    });

    this.showMenu = this.authService && this.authService.loggedIn();

    let token = sessionStorage.getItem('id_token');
    if (!token) { return ''; }
    let decodedToken = this.jwtHelper.decodeToken(token);
    this.userName = decodedToken.displayName;
  }

  clickToHide() {
    this.opened = false;
  }

  dateFormatted(): string {
    let day = this.currentDate.getDate();
    let monthIndex = this.currentDate.getMonth();
    let year = this.currentDate.getFullYear();

    return day + '.' + (monthIndex + 1) + '.' + year;
  }

  timeFormatted(): string {
    let padLeft = (num): string => {
      let pad = '00';
      return pad.substring(0, pad.length - (num + '').length) + (num + '');
    };

    let hours = this.currentDate.getHours();
    let minutes = this.currentDate.getMinutes();
    let seconds = this.currentDate.getSeconds();

    return hours + ':' + padLeft(minutes) + ':' + padLeft(seconds);
  }

  logout(): void {
      this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/menu/menu.component.ts